// ---------------------------------------------------------

import Component from './component';

// ---------------------------------------------------------

export default Component;

// ---------------------------------------------------------

export { Component as component };
